var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0C1.1125 0 0 1.1125 0 2.5V20C0 20.663 0.263392 21.2989 0.732233 21.7678C1.20107 22.2366 1.83696 22.5 2.5 22.5H20C20.663 22.5 21.2989 22.2366 21.7678 21.7678C22.2366 21.2989 22.5 20.663 22.5 20V11.25H20V20H2.5V2.5H11.25V0H2.5ZM18.475 1.25C18.2501 1.2519 18.0347 1.34161 17.875 1.5L16.35 3.0125L19.475 6.1375L21 4.625C21.325 4.3 21.325 3.75 21 3.4375L19.0625 1.5C18.9 1.3375 18.6875 1.25 18.475 1.25ZM15.4625 3.9L6.25 13.125V16.25H9.375L18.5875 7.025L15.4625 3.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.2c730dac47e7b8e3639029009346b47e.svg";
export { ForwardRef as ReactComponent };